import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Container,
  IconButton,
  Rating,
} from "@mui/material";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadLinksPreset } from "@tsparticles/preset-links";
import { handleClick } from "./home";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import logo from "../image/logo.png";
import "@fontsource/niconne";

// ================= VIDEO IMPORTS =================
// COMPANY PROFILE
import Item1 from "../video/cp1.mp4";
import Item2 from "../video/cp2.mp4";
import Item3 from "../video/cp3.mp4";
import Item4 from "../video/cp4.mp4";
// LANDING PAGE
import Item5 from "../video/lp1.mp4";
import Item6 from "../video/lp2.mp4";
import Item7 from "../video/lp3.mp4";
import Item8 from "../video/lp4.mp4";
// ONLINE STORE
import Item9 from "../video/ol1.mp4";
import Item10 from "../video/ol2.mp4";
import Item11 from "../video/ol3.mp4";
import Item12 from "../video/ol4.mp4";

// ========================= DATA PORTOFOLIO (VIDEO ONLY) =========================
const portofolioCategories = [
  {
    category: "Company Profile",
    data: [Item1, Item2, Item3, Item4],
  },
  {
    category: "Online Store",
    data: [Item9, Item10, Item11, Item12],
  },
  {
    category: "Landing Page",
    data: [Item5, Item6, Item7, Item8],
  },
];

// ========================= KOMPONEN UTAMA =========================
export default function Portofolio() {
  const [init, setInit] = React.useState(false);

  // Inisialisasi Engine particles
  React.useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadLinksPreset(engine);
    }).then(() => setInit(true));
  }, []);

  return (
    <>
      <Box sx={{ position: "relative", overflow: "hidden", bgcolor: "#f9fafb", mt: -10 }}>
        {init && (
          <Particles
            id="tsparticles"
            options={{
              preset: "links",
              background: { color: "#ffffff" },
              particles: {
                color: { value: "#31927b" },
                links: { color: "#31927b", distance: 150, enable: true, opacity: 0.4, width: 1 },
                move: { enable: true, speed: 2 },
                number: { value: 60, density: { enable: true, area: 800 } },
              },
            }}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 0,
            }}
          />
        )}

        {/* ===== Konten Utama ===== */}
        <Container
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",     // ⭐ semua konten di tengah
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >

          <Box sx={{ py: 10, textAlign: "center" }}>
            <Typography variant="h4" sx={{ fontWeight: 700, color: "#31927b" }}>
              Website{" "}
              <span
                style={{
                  color: "#fcb81c",
                  fontFamily: "Newt Serif Demi",
                  fontStyle: "italic",
                  fontSize: "1.3em",
                }}
              >
                niagawebsite
              </span>
            </Typography>
          </Box>

          {/* Loop kategori */}
          {portofolioCategories.map((section, i) => (
            <Box key={i} sx={{ mb: 10 }}>
              {/* Header kategori */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center", // ⬅️ BIAR DI TENGAH
                  gap: 2,
                  mb: 4,
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  textAlign: "center", // ⬅️ Teks juga ikut rata tengah
                }}
              >
                <Box
                  sx={{
                    display: "inline-block",
                    backgroundColor: "#31927b",
                    color: "#fff",
                    px: 5,
                    py: 2,
                    transform: "skew(-20deg)",
                    borderRadius: "6px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                  }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      transform: "skew(0deg)",
                      display: "inline-block",
                    }}
                  >
                    {section.category}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    flexGrow: 0,
                    mt: { xs: 2, md: 0 },
                    transform: "skew(-20deg)",
                    display: "inline-flex",
                    flexWrap: "wrap",
                    maxWidth: { xs: "100%", sm: "80%", md: "auto" },
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                    justifyContent: "center", // ⬅️ tengah juga untuk container ini
                  }}
                >
                  <Typography
                    className="font"
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      lineHeight: 1.4,
                      color: "silver",
                      transform: "skew(20deg)",
                      textAlign: "center", // ⬅️ teks rata tengah
                      width: "fit-content",
                      maxWidth: { xs: "90vw", sm: "80vw", md: "auto" },
                      whiteSpace: "normal",
                    }}
                  >
                    {section.category === "Company Profile"
                      ? "Membangun website perusahaan profesional"
                      : section.category === "Online Store"
                      ? "Membangun toko online modern"
                      : "Membangun landing page efektif"}
                  </Typography>
                </Box>
              </Box>


              {/* Isi portofolio: video-only */}
              <Grid container spacing={4} justifyContent="center">
                {section.data.map((videoSrc, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                    <Card
                      sx={{
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: "12px",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                        transition: "transform 0.3s, box-shadow 0.3s",
                        "&:hover": {
                          transform: "translateY(-6px)",
                          boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          position: "relative",
                          overflow: "hidden",
                          "&:hover video": {
                            filter: "brightness(0.7)",
                            transform: "scale(1.05)",
                          },
                        }}
                      >
                        <video
                          src={videoSrc}
                          width="100%"
                          height={200}
                          aria-hidden={false}
                          muted
                          loop
                          autoPlay
                          playsInline
                          // controls   <- uncomment if you want controls visible
                          style={{
                            width: "100%",
                            height: 200,
                            objectFit: "cover",
                            transition: "0.4s ease",
                            display: "block",
                          }}
                        />
                      </Box>

                      {/* Optional small footer inside card (kehilangan title/link sesuai permintaan)
                          jika tidak wanted at all, kita bisa hapus CardContent sepenuhnya.
                          Saat ini saya tinggalkan area kecil untuk menjaga layout konsisten. */}
                      <CardContent sx={{ py: 1, px: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography variant="body2" sx={{ color: "#555", fontWeight: 600 }}>
                            Top Desain
                          </Typography>
                          <Rating name="read-only" value={5} readOnly size="small" sx={{ color: "#fcb81c" }} />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Container>

        {/* ===== FOOTER ===== */}
        <Container sx={{ position: "relative", zIndex: 1 }}>
          <Box
            component="footer"
            sx={{
              bgcolor: "#f7f7f7",
              color: "#333",
              mt: 10,
              pt: 8,
              pb: 4,
              px: { xs: 3, md: 10 },
            }}
          >
            <Grid container spacing={6}>
              {/* Kolom 1: Logo & Deskripsi */}
              <Grid item xs={12} md={4}>
                <Box component="img" src={logo} alt="niagawebsite Logo" sx={{ height: 100, mb: 2 }} />
                <Typography className="font" sx={{ mb: 2 }}>
                  <b style={{ color: "#31927b" }}>niagawebsite</b> adalah penyedia jasa pembuatan website profesional
                  yang membantu Anda membangun identitas digital yang kuat. Kami percaya bahwa setiap bisnis berhak tampil
                  modern dan mudah ditemukan di internet.
                </Typography>
                <Typography className="font" sx={{ mb: 2 }}>
                  Dengan kombinasi desain kreatif, performa cepat, dan strategi digital yang efektif, kami hadir untuk membantu
                  bisnis Anda berkembang melalui website yang menarik, responsif, dan terpercaya.
                </Typography>
              </Grid>

              {/* Kolom 2: Navigasi */}
              <Grid item xs={12} md={3}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#31927b", mb: 2 }}>
                  Navigasi
                </Typography>
                {["Beranda", "Layanan", "Paket Website", "Portofolio", "Testimoni", "Kontak"].map((item, i) => (
                  <Typography
                    className="font"
                    key={i}
                    sx={{
                      mb: 1,
                      cursor: "pointer",
                      "&:hover": { color: "#fcb81c" },
                      transition: "0.3s",
                    }}
                  >
                    {item}
                  </Typography>
                ))}
              </Grid>

              {/* Kolom 3: Informasi Kontak */}
              <Grid item xs={12} md={3}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: "#31927b", mb: 2 }}>
                  Hubungi Kami
                </Typography>
                <Box sx={{ width: "100%", height: 380, borderRadius: 2, overflow: "hidden", mb: 2 }}>
                  <iframe
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer-when-downgrade"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.035632779391!2d106.8466307749855!3d-6.514347564293742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69e9e9d33f89cf%3A0xe1747460dbc0b99b!2sJl.%20Madrasah%20No.91%2C%20RT.3%2FRW.9%2C%20Pekayon%2C%20Ps.%20Rebo%2C%20Jakarta%20Timur%2013710!5e0!3m2!1sid!2sid!4v1732518760000"
                  ></iframe>
                </Box>
                <Typography className="font" sx={{ mb: 1 }}>
                  📍 Jln Madrasah No. 91, RT.3/RW.9, Pekayon, Pasar Rebo, Jakarta timur 13710
                </Typography>
                <Typography className="font" sx={{ mb: 1 }}>
                  📞 085178231007
                </Typography>
                <Typography className="font" sx={{ mb: 2 }}>
                  ✉️ niagawebsite21@gmail.com
                </Typography>
                <Typography className="font" sx={{ color: "#555" }}>
                  Kami selalu siap membantu Anda membangun website impian. Hubungi kami untuk konsultasi gratis dan dapatkan
                  solusi terbaik untuk kebutuhan digital Anda.
                </Typography>
              </Grid>
            </Grid>

            {/* Garis Pembatas */}
            <Box sx={{ mt: 8, mb: 2, borderTop: "1px solid #ddd", pt: 3, textAlign: "center" }}>
              <Typography className="font" sx={{ fontSize: "0.9rem", color: "#666" }}>
                © {new Date().getFullYear()} <b style={{ color: "#31927b" }}>niagawebsite</b> — Semua hak cipta dilindungi.
                Dibuat dengan semangat dan inovasi 💡 untuk membantu Anda memiliki website yang lebih baik.
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>

      <Box
        id="whatsapp-btn"
        sx={{
          position: "fixed",
          bottom: { xs: 16, md: 20 },
          right: { xs: 16, md: 20 },
          zIndex: 2147483647,
          pointerEvents: "auto",
        }}
      >
        <span className="pulse-ring" />
        <IconButton
          onClick={handleClick}
          sx={{
            bgcolor: "#25D366",
            "&:hover": { bgcolor: "#1ebe5d" },
            color: "#fff",
            width: { xs: 52, md: 60 },
            height: { xs: 52, md: 60 },
            borderRadius: "50%",
            boxShadow: "0 6px 12px rgba(0,0,0,0.3)",
            zIndex: 2147483647,
          }}
        >
          <WhatsAppIcon sx={{ fontSize: { xs: 28, md: 32 } }} />
        </IconButton>
      </Box>
    </>
  );
}
